import React, { useState,useEffect, useRef } from "react";
import { useHistory } from 'react-router-dom';
import axiosInstance from "../../services/api";
import Logo from "../../assets/images/logo.svg"
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
import {Link } from 'react-router-dom'
// import Cookies from 'js-cookie';
const OTP_LENGTH = 6; // Change this for different OTP lengths

const OtpFrom = () => {
  const accessToken = localStorage.getItem("accessToken");
  const userEmail = localStorage.getItem("userEmail");
  const nextRetryOtpTime = localStorage.getItem("nextRetryOtpTime");
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState(new Array(OTP_LENGTH).fill(""));
  const inputRefs = useRef([]);
  const history = useHistory();
  const [timer, setTimer] = useState(nextRetryOtpTime);
  const handleChange = (e, index) => {
    const value = e.target.value;
    if (isNaN(value)) return; // Only allow numbers

    let newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1); // Ensure single digit
    setOtp(newOtp);

    // Move to next input
    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  // Handle backspace
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
      if (timer > 0) {
        const interval = setInterval(() => {
          setTimer((prev) => prev - 1);
        }, 1000);
        return () => clearInterval(interval);
      }
    }, [timer]);

  // Handle submission
  const handleSubmit = async (e) => {
    toast.dismiss();
    setLoading(true);
    const otpValue = otp.join("");
    
    try {
      const response = await axiosInstance.post('auth/validate-otp', {
        otp: otpValue, // Send the OTP in the request body
      });
    
      setOtp(new Array(OTP_LENGTH).fill("")); // Clear the OTP input
      console.log("OTP Validation Success:", response.data);
      if (response.data.status.code === 200) {
        toast.success(response.data.status.message);
      } else {
        toast.error(response.data.status.message);
      }
      const { refreshToken, accessToken, passwordUpdated } = response.data.data;
      //const passwordUpdated = false;
      if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        localStorage.setItem("refreshToken", refreshToken); // Change to localStorage if needed
        localStorage.setItem("otpVerified", "true"); // ✅ Store OTP verification
        localStorage.setItem('passwordUpdated', passwordUpdated);
        //localStorage.removeItem("passwordVerified");
        if(passwordUpdated === false){
          console.log("change")
         history.push('/changepassword'); // Use navigate instead of history.push
        }else{
          console.log("dash")
         history.push('/dashboard'); // Use navigate instead of history.push
        }
      }
    } catch (error) {
      console.log("kkk")
      
      console.error('Error validating OTP:', error);
    }finally {
      setLoading(false);
    }
  };
  
  const handleResendOTP = async (e) => {
    toast.dismiss();
    setLoading(true);
    try {
      const response = await axiosInstance.get('auth/resend-otp');
      setOtp(new Array(OTP_LENGTH).fill(""));
  
      if (response.data.status.code === 200) {
        toast.success(response.data.status.message);
        if (timer === 0) {
          setTimer(response.data.data.nextOtpRetryAfter); // Set timer as a number
        }
      } else {
        toast.error(response.data.status.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }finally {
      setLoading(false);
    }
  };
  
  const isDisabled = otp.some((digit) => digit === "");
  const backToLogin = async () => {
    localStorage.clear();
    setTimeout(() => {
      //history.replace('/login'); // Replace with your navigation logic
      window.location.reload(); 
    }, 100); 
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();
    
    if (/^\d{6}$/.test(pastedData)) { // Ensure it's exactly 6 digits
      const newOtp = pastedData.split(""); // Convert string to array
      setOtp(newOtp);
      
      // Auto-focus next inputs
      newOtp.forEach((digit, index) => {
        if (inputRefs.current[index]) {
          inputRefs.current[index].value = digit;
          if (index < OTP_LENGTH - 1) {
            inputRefs.current[index + 1].focus();
          }
        }
      });
    }
  };

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     if (!sessionStorage.getItem("sessionActive")) {
  //       localStorage.clear();
  //       sessionStorage.clear();
  //     }
  //   };
  
  //   // Set a session flag when the user is inside the app
  //   sessionStorage.setItem("sessionActive", "true");
  
  //   // Attach event listener
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);
  
  return (
    <>
    {loading && <Loader />} 
    <div className='login-wrapper'>
      <div className="login-form otp-form">
          <div className='login-left'>
              <img src={Logo} alt=""/>
          </div>
          <div className='login-right'>
            <h2>Enter OTP</h2>
            <p>The OTP is sent on email  <span>{userEmail}</span></p>
            <div className="otp-container">
              <label htmlFor="username">Enter OTP</label>
              <div className="otp-inputs">
                  
                  {otp.map((_, index) => (
                  <input
                      key={index}
                      type="tel"
                      maxLength="1"
                      value={otp[index]}
                      onChange={(e) => handleChange(e, index)}
                      onKeyDown={(e) => handleKeyDown(e, index)}
                      onPaste={handlePaste}
                      ref={(el) => (inputRefs.current[index] = el)}
                  />
                  ))}
              </div>
              {/* <p>OTP has been successfully sent. 
              It will be expire in 20 seconds</p> */}
              {/* {error && <p style={{ color: 'red' }}>{error}</p>}
              {successMessage && <p style={{ color: 'green' }}>{successMessage}</p>} */}
              <button onClick={handleSubmit} disabled={isDisabled}>Verify OTP</button>
              <br/>
              <a onClick={handleResendOTP} className="resend-otp"  disabled={timer > 0}>{timer > 0 ? `Resend OTP in ${timer}s` : "Resend OTP"}</a>
            </div>
            <div>
                <a onClick={backToLogin} className='btn-link'>Back To Login</a>
            </div>
          </div>
      </div>
    </div>
    </>
  );
};

export default OtpFrom;
